module.exports = __webpack_public_path__ + "img/logoFull.bdc3272f.png";